import { api } from './api'

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000'

// Stream/preview URL for a file guide (sends the auth cookie, same-site).
export function guideFileUrl(fileId) {
  return `${BASE_URL}/guides/file/${fileId}`
}

// Where a guide "opens": its URL for link guides, or the streamed file otherwise.
export function guideOpenUrl(guide) {
  if (!guide) return ''
  return guide.kind === 'url' ? guide.url : guideFileUrl(guide.fileId)
}

// Coarse kind used to pick an icon / preview style.
export function guideKind(guide) {
  if (!guide) return 'file'
  if (guide.kind === 'url') return 'url'
  const type = guide.contentType || ''
  if (type.startsWith('image/')) return 'image'
  if (type.startsWith('video/')) return 'video'
  if (type === 'application/pdf') return 'pdf'
  return 'file'
}

// List the user's guides. Optional { q, topics, items } narrow the results.
export function listGuides({ q, topics, items, nested } = {}) {
  const params = new URLSearchParams()
  if (q) params.set('q', q)
  if (topics?.length) params.set('topics', topics.join(','))
  if (items?.length) params.set('items', items.join(','))
  if (nested) params.set('nested', '1')
  const query = params.toString()
  return api.get(`/guides${query ? `?${query}` : ''}`).then((data) => data.guides)
}

export function getGuide(id) {
  return api.get(`/guides/${id}`).then((data) => data.guide)
}

// Create a guide. payload: { kind:'url'|'file', title?, description?, url?, fileId?,
// topics?, items? }.
export function createGuide(payload) {
  return api.post('/guides', payload).then((data) => data.guide)
}

export function updateGuide(id, changes) {
  return api.patch(`/guides/${id}`, changes).then((data) => data.guide)
}

export function deleteGuide(id) {
  return api.del(`/guides/${id}`).then((data) => data.guide)
}

// Upload a single file for a file guide. Resolves to { fileId, name, contentType,
// size } to send with createGuide({ kind: 'file', ... }).
export async function uploadGuideFile(file) {
  const form = new FormData()
  form.append('file', file)
  const res = await fetch(`${BASE_URL}/guides/upload`, {
    method: 'POST',
    credentials: 'include',
    body: form,
  })
  if (!res.ok) {
    let message = 'Upload failed'
    try {
      const data = await res.json()
      message = data.error || message
    } catch {
      /* non-JSON error */
    }
    throw new Error(message)
  }
  return res.json().then((data) => data.attachment)
}
